module.exports = __webpack_public_path__ + "img/vaccine.1271ea47.svg";